import {Component, OnInit, HostListener, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SharedService} from '../shared.service';
import {LocationStrategy} from '@angular/common';
import {UserService} from '../user/user.service';

@Component({
    selector: 'app-error-dialog',
    templateUrl: './error-dialog.component.html'
})
export class ErrorDialogComponent implements OnInit {

    // Injected Properties
    apiCall: string

    // Local Properties
    user: string;
    fullPath: string;
    programName: string;
    message: string;
    stackTrace: string;
    showErrorDetails = false;
    currentDate: Date = new Date();

    constructor(
        @Inject(MAT_DIALOG_DATA) private data: any,
        private sharedService: SharedService,
        private userService: UserService,
        private dialogRef: MatDialogRef<ErrorDialogComponent>,
        private location: LocationStrategy
    ) {}

    @HostListener('document:keydown', ['$event'])
    onKeyDown(event: Event) {
        let keyEvent: KeyboardEvent = event as KeyboardEvent;
        if (keyEvent.keyCode == 69 && keyEvent.ctrlKey && keyEvent.shiftKey) {
            this.sharedService.getErrorDetails(this.userService.userId, this.apiCall).subscribe(errorDetail => {
                if (errorDetail != undefined || errorDetail != null) {
                    this.showErrorDetails = true;
                    const substrings = errorDetail.split('||');
                    this.programName = substrings[0];
                    this.message = substrings[1];
                    this.stackTrace = substrings[2];
                }
            });
        }
    }

    ngOnInit() {
        this.fullPath = (<any>this.location)._platformLocation.location.href;
        this.user = this.userService.username;
        if (this.data && this.data.apiCall) {
            this.apiCall = this.data.apiCall;
        }
    }

    closeClick() {
        this.dialogRef.close('Close was clicked.');
    }
}
